import React from 'react'
import loginFunction from '../../views/login/login.functions';
import * as Icons from '../../assets/iconos';

function AdminNavigation({ navigate, config, pathname }) {
  return (
    <div className="scrollbar-container">
        <ul id="sidebarnv" className="nv">
          <li className="sidebar-item">
            <div className="name-company d-flex flex-column align-items-start">
              <div>{config.nombre_empresa.toUpperCase()}</div>
              <div>{config.username.toUpperCase()}</div>
            </div> 
          </li>
          <li className={`sidebar-item bordernav ${pathname === '/dashboard' && 'navActive'}`}>
            <a onClick={() => navigate('/dashboard')} className="sidebar-link">
              <img src={Icons.Icono01} className="icon-nav" />
              <span>Dashboard</span>
            </a>
          </li>
          <li className={`sidebar-item bordernav ${pathname === '/ventas' && 'navActive'}`}>
            <a onClick={() => navigate('/ventas')} className="sidebar-link">
              <img src={Icons.Icono18} className="icon-nav" />
              <span>Ventas</span>
            </a>
          </li>
          <li className={`sidebar-item bordernav ${pathname === '/clientes' && 'navActive'}`}>
            <a onClick={() => navigate('/clientes')} className="sidebar-link">
              <img src={Icons.Icono02} className="icon-nav" />
              <span>Clientes</span>
            </a>
          </li>
          <li className={`sidebar-item bordernav ${pathname === '/master' && 'navActive'}`}>
            <a onClick={() => navigate('/master')} className="sidebar-link">
              <img src={Icons.Icono03} className="icon-nav" />
              <span>Salidas programadas</span>
            </a>
          </li>
          <li className={`sidebar-item bordernav ${pathname === '/paquetes' && 'navActive'}`}>
            <a onClick={() => navigate('/paquetes')} className="sidebar-link">
              <img src={Icons.Icono05} className="icon-nav" />
              <span>Crear guia</span>
            </a>
          </li>
          <li className={`sidebar-item bordernav ${pathname === '/estados' && 'navActive'}`}>
            <a onClick={() => navigate('/estados')} className="sidebar-link">
              <img src={Icons.Icono04} className="icon-nav" />
              <span>Cambiar estados</span>
            </a>
          </li>
          <li className={`sidebar-item bordernav ${pathname === '/entrega' && 'navActive'}`}>
            <a onClick={() => navigate('/entrega')} className="sidebar-link">
              <img src={Icons.Icono06} className="icon-nav" />
              <span>Buscar paquete</span>
            </a>
          </li>
          <li className={`sidebar-item bordernav ${pathname === '/boletines' && 'navActive'}`}>
            <a onClick={() => navigate('/boletines')} className="sidebar-link">
              <img src={Icons.Icono07} className="icon-nav" />
              <span>Boletines</span>
            </a>
          </li>
          <li className={`sidebar-item bordernav ${pathname === '/sucursal' && 'navActive'}`}>
            <a onClick={() => navigate('/sucursal')} className="sidebar-link">
              <img src={Icons.Icono10} className="icon-nav" />
              <span>Sucursales</span>
            </a>
          </li>
          <li className={`sidebar-item bordernav ${pathname === '/configuracion' && 'navActive'}`}>
            <a onClick={() => navigate('/configuracion')} className="sidebar-link">
              <img src={Icons.Icono08} className="icon-nav" />
              <span>Configuración</span>
            </a>
          </li>
          <li className={`sidebar-item bordernav ${pathname === '/reportes' && 'navActive'}`}>
            <a onClick={() => navigate('/reportes')} className="sidebar-link">
              <img src={Icons.Icono09} className="icon-nav" />
              <span>Reportes</span>
            </a>
          </li>
          <li className="sidebar-item bordernav">
            <a onClick={() => loginFunction.logout()} className="sidebar-link">
              <img src={Icons.Icono11} className="icon-nav" />
              <span>Salir</span>
            </a>
          </li>
        </ul>
     </div>
  )
}

function GestorNavigation({ navigate, config, pathname }) {
  return (
    <div className="scrollbar-container">
      <ul id="sidebarnv" className="nv">
        <li className="sidebar-item">
          <div className="name-company">
            {config.nombre_empresa.toUpperCase()}
          </div> 
        </li>
        <li className={`sidebar-item bordernav ${pathname === '/dashboard' && 'navActive'}`}>
            <a onClick={() => navigate('/dashboard')} className="sidebar-link">
              <img src={Icons.Icono01} className="icon-nav" />
              <span>Dashboard</span>
            </a>
        </li>
        <li className={`sidebar-item bordernav ${pathname === '/clientes' && 'navActive'}`}>
            <a onClick={() => navigate('/clientes')} className="sidebar-link">
              <img src={Icons.Icono02} className="icon-nav" />
              <span>Clientes</span>
            </a>
          </li>
          <li className={`sidebar-item bordernav ${pathname === '/ventas' && 'navActive'}`}>
            <a onClick={() => navigate('/ventas')} className="sidebar-link">
              <img src={Icons.Icono18} className="icon-nav" />
              <span>Ventas</span>
            </a>
          </li>
          <li className={`sidebar-item bordernav ${pathname === '/paquetes' && 'navActive'}`}>
            <a onClick={() => navigate('/paquetes')} className="sidebar-link">
              <img src={Icons.Icono05} className="icon-nav" />
              <span>Crear guia</span>
            </a>
          </li>
          <li className={`sidebar-item bordernav ${pathname === '/entrega' && 'navActive'}`}>
            <a onClick={() => navigate('/entrega')} className="sidebar-link">
              <img src={Icons.Icono06} className="icon-nav" />
              <span>Buscar paquete</span>
            </a>
          </li>
        <li className="sidebar-item bordernav">
            <a onClick={() => navigate('/contrasena')} className="sidebar-link">
              <img src={Icons.Icono12} className="icon-nav" />
              <span>Cambiar contraseña</span>
            </a>
          </li>
          <li className="sidebar-item bordernav">
            <a onClick={() => loginFunction.logout()} className="sidebar-link">
              <img src={Icons.Icono11} className="icon-nav" />
              <span>Salir</span>
            </a>
          </li>
      </ul>
   </div>
  )
}

function MasterNavigation({ navigate, config, pathname }) {
  return (
    <div className="scrollbar-container">
      <ul id="sidebarnv" className="nv">
        <li className="sidebar-item">
          <div className="name-company">
            {config.nombre_empresa.toUpperCase()}
          </div> 
        </li>
        <li className={`sidebar-item bordernav ${pathname === '/dashboard' && 'navActive'}`}>
            <a onClick={() => navigate('/dashboard')} className="sidebar-link">
              <img src={Icons.Icono01} className="icon-nav" />
              <span>Dashboard</span>
            </a>
        </li>
        <li className="sidebar-item bordernav">
            <a onClick={() => loginFunction.logout()} className="sidebar-link">
              <img src={Icons.Icono11} className="icon-nav" />
              <span>Salir</span>
            </a>
          </li>
      </ul>
   </div>
  )
}

export {
  AdminNavigation,
  GestorNavigation,
  MasterNavigation,
}